import React from 'react'
import Header from '../../../components/Header'
import Report from './Report'

const MessageLogReport = () => {
  
    let encodedData = localStorage.getItem('data')
    let data = JSON.parse(atob(encodedData))
    return (
        <div>
            <Header />
            <Report data={data}/>
        </div>
    )
}

export default MessageLogReport